import { api, getQueryString } from "../common/utils"
import { AUDIT_LOGS_ENDPOINT } from "../common/constants"

export interface AuditLog {
  id: string
  created: string
  event_type: string
  severity: string
  user_id: string | null
  target_id: string | null
  ip_address: string | null
  details: Record<string, unknown> | null
  log_hash: string
}

export interface AuditLogsResponse {
  status: string
  logs: AuditLog[]
  total: number
  limit: number
  has_more: boolean
  next_cursor: string | null
}

export interface AuditTimelineBucket {
  timestamp: number
  total: number
  events: Record<string, number>
}

export interface AuditTimelineResponse {
  status: string
  interval: string
  from: number
  to: number
  buckets: AuditTimelineBucket[]
}

const auditLogs = {
  getLogs: async (
    params: Record<string, string | number | boolean | undefined>
  ): Promise<AuditLogsResponse> => {
    const { data } = await api.get(AUDIT_LOGS_ENDPOINT + getQueryString(params))
    return data
  },
  getTimeline: async (
    params: Record<string, string | number | boolean | undefined>
  ): Promise<AuditTimelineResponse> => {
    const { data } = await api.get(
      AUDIT_LOGS_ENDPOINT + getQueryString({ ...params, aggregate: "timeline" })
    )
    return data
  }
}

export default auditLogs
